import { api, endpoints } from "api/api";
import { AxiosPromise, AxiosResponse } from "axios";
import { UserApi } from "./users/usersApi";
import { CourseBaseInfoDto } from "./courses/coursesApi";
import { ExamQuestionApi } from "./examsApi";
import { CourseExamPaymentStatus, ExamStatusIds } from "consts";

const fetchUserExams = (courseId: number, userId: number): AxiosPromise<{ exams: UserCourseExamApi[] }> => {
  return api.get<{ exams: UserCourseExamApi[] }>(endpoints.USER_EXAMS.GET_USER_EXAMS(courseId, userId));
};

const downloadFile = (
  courseId: number,
  courseExamId: number,
  userId: number,
  userExamId: number,
  fileId: number,
): AxiosPromise<AxiosResponse<Blob>> => {
  return api.get(endpoints.USER_EXAMS.DOWNLOAD_FILE(courseId, courseExamId, userId, userExamId, fileId), {
    responseType: "blob",
  });
};

const cancelPayment = (courseId: number, courseExamId: number, userId: number): AxiosPromise => {
  return api.post(endpoints.USER_EXAMS.CANCEL_PAYMENT(courseId, courseExamId, userId));
};
const fetchUserExam = (
  courseId: number,
  courseExamId: number,
  userId: number,
  userExamId: number,
): AxiosPromise<FetchUserExamResponse> => {
  return api.get<FetchUserExamResponse>(endpoints.USER_EXAMS.GET_USER_EXAM(courseId, courseExamId, userId, userExamId));
};

const reviewUserExam = (
  courseId: number,
  courseExamId: number,
  userId: number,
  userExamId: number,
  body: ReviewExamBody,
): AxiosPromise => {
  return api.post<FetchUserExamResponse>(
    endpoints.USER_EXAMS.REVIEW_USER_EXAM(courseId, courseExamId, userId, userExamId),
    body,
  );
};

export const userExamsApi = {
  fetchUserExam,
  reviewUserExam,
  fetchUserExams,
  cancelPayment,
  downloadFile,
};
export interface UserCourseExamApi {
  courseExamId: number;
  examId: number;
  name: string;
  description: string;
  attempts: UserCourseExamAttemptApi[];
  nextAttemptPrice: number;
}

export interface UserCourseExamAttemptApi {
  userExamId: number;
  fillingDate?: Date;
  createdDate: Date;
  result: {
    status: ExamStatusIds;
    reviewComment: string;
  };
  payment: {
    amount: string;
    status: CourseExamPaymentStatus;
    link?: string;
    hasInvoice: boolean;
  };
}

export interface ReviewExamBody {
  answers: {
    questionId: number;
    comment?: string;
    passed: boolean | null;
    points: number | null;
  }[];
  comment?: string;
  passed?: boolean;
}
export interface FetchUserExamResponse {
  userExam: UserExamApi;
  course: CourseBaseInfoDto;
  user: UserApi;
}

export interface UserExamApi {
  userExamId: number;
  status: ExamStatusIds;
  name: string;
  reviewComment?: string;
  description: string;
  userId: number;
  courseExamId: number;
  answers: UserExamAnswerApi[];
}
export interface UserExamAnswerApi {
  userExamAnswerId: number;
  examQuestionId: number;
  question: ExamQuestionApi;
  value: string;
  rating: number;
  review: UserExamAnswerReviewApi;
  files: UserExamAnswerFileApi[];
}
export interface UserExamAnswerFileApi {
  id: number;
  fileName: string;
  originalFileName: string;
}
export interface UserExamAnswerReviewApi {
  comment?: string;
  passed: boolean | null;
  points: number | null;
  reviewer?: UserApi;
}
